<template>
  <div class="short-profile-box">
    <div class="short-profile-box-inner flex flex-col items-center mt-10">
      <img
          v-if="currentUser.avatar"
          :src="currentUser.avatar.replace('/original/', '/200x200/')"
          loading="lazy"
          width="200"
          height="200"
      />
      <img
          v-else
          class="userIconPlaceholder"
          :src="assetDomain + 'assets/icon_placeholder.svg'"
          loading="lazy"
          width="200"
          height="200"
      />

      <div class="details">
        <h5 class="text-black">{{ currentUser.title }}<br />{{ displayName }}</h5>
        <p class="text-black">{{ currentUser.email }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import {ASSET_DOMAIN} from "@/services";

export default {
  name: "ShortProfileBox",
  data() {
    return {
      assetDomain: ASSET_DOMAIN,
      visible: true,
      forgotPwd: false,
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    displayName() {
      return `${this.currentUser.firstname} ${this.currentUser.lastname}`;
    },
  },
};
</script>

<style scoped>
.userIconPlaceholder {
  filter: invert(1)
}
.short-profile-box-inner {

  img {
    vertical-align: middle;
  }
  &::v-deep h4 {
    @apply font-medium;
  }
}

.details {
  h5,p {
    vertical-align: middle;
    text-align: center;
  }
}
</style>
